import { ComplianceCaseTypeEnum } from "#graphql/supergraphEnums";
import type { ComplianceCaseTypeEnum as ComplianceCaseType } from "#graphql/supergraphTypes";

export const GP_CASE_TYPE_LABELS: Partial<Record<ComplianceCaseType, string>> = {
  [ComplianceCaseTypeEnum.InvestorOnboarding]: "Investor onboarding",
  [ComplianceCaseTypeEnum.Escalation]: "Escalation",
  [ComplianceCaseTypeEnum.RecurringHit]: "Screening",
  [ComplianceCaseTypeEnum.Remediation]: "Remediation",
  [ComplianceCaseTypeEnum.ProfileRefresh]: "Profile refresh",
  [ComplianceCaseTypeEnum.ChangeInCircumstance]: "Change in circumstance",
  [ComplianceCaseTypeEnum.DocumentRefresh]: "Document refresh",
  [ComplianceCaseTypeEnum.PaymentInstructionChangeReview]: "Payment instruction review",
};
